import { SectionIntro } from '@/app/_components/core/section-intro';
import type { IntroWithAlignment } from '@/entities/models/page';

interface EventBentoIntroProps {
  intro: IntroWithAlignment;
  trackingPrefix?: string;
}

export function EventBentoIntro({ intro, trackingPrefix }: EventBentoIntroProps) {
  return <SectionIntro intro={intro} withMoreLink trackingPrefix={trackingPrefix} />;
}
